// Shared status configuration for all Methanol charts and panels.
// Labels and colors are derived from SVG badge icons for all 16 asset statuses.
// Import this wherever status key → label/color mapping is needed to avoid drift.
export const METHANOL_STATUS_CONFIG = {
    charging: { color: "#1AC69E", label: "Charging" },
    coldstandby: { color: "#4D94FF", label: "Cold Standby" },
    cooldown: { color: "#4D94FF", label: "Cooldown" },
    cooling: { color: "#4D94FF", label: "Cooling" },
    fault: { color: "#D80000", label: "Fault" },
    hotstandby: { color: "#FB5A00", label: "Hot Standby" },
    idle: { color: "#8CBAFF", label: "Idle" },
    lowpressure: { color: "#D80000", label: "Low Pressure" },
    maintenance: { color: "#696969", label: "Maintenance" },
    move: { color: "#696969", label: "Move" },
    off: { color: "#909090", label: "Off" },
    online: { color: "#0066FF", label: "Online" },
    preparingforstandby: { color: "#909090", label: "Preparing For Standby" },
    producing: { color: "#1AC69E", label: "Producing" },
    production: { color: "#1AC69E", label: "Production" },
    standby: { color: "#909090", label: "Standby" },
    warming: { color: "#FB5A00", label: "Warming" }
};
